module.exports = __webpack_public_path__ + "static/img/8areaB_06.91628a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/8areaB_06.png
// module id = 1235
// module chunks = 1